module.exports = __webpack_public_path__ + "static/img/c.12814645.svg";